<template>
    <v-container fluid class="py-0">
        <v-row>
            <!--            <v-col cols="3" sm="3" class="pb-0">-->
            <!--&lt;!&ndash;                <div class="pt-5">Timestamp: {{ updatedAt | dateFormat('YYYY.MM.DD HH:mm:ss') }}</div>&ndash;&gt;-->
            <!--            </v-col>-->
            <v-col cols="3" sm="3" class="pb-0">
                <v-menu open-on-hover>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn color="link" dark v-bind="attrs" v-on="on" class="mt-3">
                            Filters
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item v-for="(item, index) in filterOptions" :key="index" @click="setFilter(item.id)">
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-col>
            <v-col cols="3" sm="3" class="pb-0">
                <v-select
                        v-model="filterByCard"
                        :items="cards"
                        item-text="name"
                        item-value="id"
                        label="Card"
                        clearable
                        single-line
                ></v-select>
            </v-col>
            <v-col cols="3" sm="3" class="pb-0">
                <v-select
                        v-model="sortBy"
                        :items="orderByItems"
                        item-text="title"
                        item-value="id"
                        label="Select"
                        single-line
                ></v-select>
            </v-col>
            <v-col cols="3" sm="3" class="pb-0">
                <v-text-field v-model="searchBy" clearable label="Find..."></v-text-field>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {mapState} from "vuex";
    import {toArray} from "lodash";

    export default {
        name: 'GridFilter',
        data: () => ({
            orderByItems: [
                {id: 'code', title: 'Code'},
                {id: 'status_id', title: 'Status Id'},
                {id: 'hash_rate_percent', title: 'Percent'},
            ],
        }),
        computed: {
            filterByCard: {
                get() {
                    return this.$store.state.computers.filterByCard;
                },
                set(value) {
                    this.$store.commit('computers/setFilterByCard', value);
                }
            },
            searchBy: {
                get() {
                    return this.$store.state.computers.searchBy;
                },
                set(value) {
                    this.$store.commit('computers/setSearchBy', value);
                }
            },
            sortBy: {
                get() {
                    return this.$store.state.computers.sortBy;
                },
                set(value) {
                    this.$store.commit('computers/setSortBy', value);
                }
            },
            ...mapState({
                updatedAt: state => state.computers.updatedAt,
                sortByDirection: state => state.computers.sortByDirection,
                cards: state => toArray(state.cards.items),
                filterOptions: state => state.computers.filterOptions,
            }),
        },
        methods: {
            setFilter(key) {
                this.$store.dispatch('computers/setFilter', key);
            },
        },
        beforeDestroy() {
        },
        created() {
        }
    }
</script>
